import { render, staticRenderFns } from "./RegulatoryUpdateTemplate.vue?vue&type=template&id=78b30c79&scoped=true&"
import script from "./RegulatoryUpdateTemplate.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdateTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatoryUpdateTemplate.vue?vue&type=style&index=0&id=78b30c79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b30c79",
  null
  
)

export default component.exports